import { render, staticRenderFns } from "./sassCustomerList.vue?vue&type=template&id=4ca46092&scoped=true&"
import script from "./sassCustomerList.vue?vue&type=script&lang=js&"
export * from "./sassCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./sassCustomerList.vue?vue&type=style&index=0&id=4ca46092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca46092",
  null
  
)

export default component.exports